import { render, staticRenderFns } from "./TableDetail.vue?vue&type=template&id=1697b37a"
import script from "./TableDetail.vue?vue&type=script&lang=js"
export * from "./TableDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports